import { render, staticRenderFns } from "./selectProductType.vue?vue&type=template&id=acf15690&scoped=true"
import script from "./selectProductType.vue?vue&type=script&lang=js"
export * from "./selectProductType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acf15690",
  null
  
)

export default component.exports